import { styles } from './styles';

interface SignaturePreviewProps {
  signatureUrl: string;
}

export function SignaturePreview({ signatureUrl }: SignaturePreviewProps) {
  return (
    <div style={styles.previewContainer}>
      <img
        src={signatureUrl}
        alt="Signature"
        style={styles.previewImage}
      />
    </div>
  );
}
